import { render, staticRenderFns } from "./LogoSmallIcon.vue?vue&type=template&id=787a4e84&"
import script from "./LogoSmallIcon.vue?vue&type=script&lang=js&"
export * from "./LogoSmallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports